import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Identifier, ProductCategory } from '../../../../types/types';

export interface CategoryPathCellRendererComponentParams {
  category?: ProductCategory;
  categories?: Identifier[];
}
@Component({
    selector: 'category-cell-renderer-wrapper',
    templateUrl: './category-cell-renderer-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryCellRendererWrapperComponent
  implements ICellRendererAngularComp
{
  categories: Identifier[] = [];

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  agInit({ category, categories }: CustomParams): void {
    if (category) {
      this.categories = this.buildCategories(category);
    } else {
      this.categories = categories || [];
    }
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }

  private buildCategories = (category?: ProductCategory): Identifier[] => {
    if (!category) return [];

    const { name, id } = category;
    const categoryParents = category.parents ? [...category.parents] : [];
    return [
      ...categoryParents,
      {
        name,
        id,
      },
    ];
  };
}

interface CustomParams
  extends ICellRendererParams<unknown, unknown>,
    CategoryPathCellRendererComponentParams {}
